// import "./giftcard.module.scss";

import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";

import { useAddToCart } from "../hooks/useAddToCart";
import useLocalCart from "../hooks/useLocalCart";
import { useConfig } from "../lib/useConfig";
import GiftCardOptions from "./GiftCardOptions";

const GiftCardForm = ({ submit }: { submit: () => void }) => {
  const { addToCart } = useAddToCart();

  const { updateCart } = useLocalCart();
  const { config } = useConfig();

  type GiftcardType = "predeterminedAmount" | "anyAmount";

  const typeSchema: Yup.Schema<GiftcardType> = Yup.string()
    .oneOf(["predeterminedAmount", "anyAmount"])
    .required("Required");
  return (
    <Formik
      initialValues={{
        "gift-card": "",
        amount: 0,
        type: "predeterminedAmount",
        recieverName: "",

        senderName: "",

        message: "",
      }}
      validationSchema={Yup.object({
        senderName: Yup.string().required("Required"),
        recieverName: Yup.string().required("Required"),

        "gift-card": Yup.string().required("Required"),
        type: typeSchema,
        amount: Yup.number(),

        message: Yup.string().optional(),
      })}
      onSubmit={(values, { setSubmitting, validateForm, setFieldError }) => {
        if (values?.type === "anyAmount" && values?.amount <= 0) {
          setFieldError("amount", "Amount should be higher than 0");
          return;
        }
        validateForm();
        updateCart(values);

        addToCart.mutate({
          giftcardId: values["gift-card"] as string,
          amount: values?.type === "anyAmount" ? values?.amount : undefined,
        });

        setSubmitting(false);
        submit();
      }}
    >
      <Form className="giftcard-form">
        <div className="form-values checkbox">
          <GiftCardOptions />
        </div>
        <div>
          <label htmlFor="senderName">
            {config?.configFields.senderName.label}
          </label>
          <Field
            name="senderName"
            type="text"
            required
            placeholder={
              config?.options?.noPlaceholders
                ? null
                : config?.configFields.senderName.placeholder
            }
          />
          <span className="error">
            <ErrorMessage name="senderName" />
          </span>
        </div>
        <div>
          <label htmlFor="recieverName">
            {config?.configFields.recieverName.label}
          </label>
          <Field
            name="recieverName"
            type="text"
            required
            placeholder={
              config?.options?.noPlaceholders
                ? null
                : config?.configFields.recieverName.placeholder
            }
          />

          <span className="error">
            <ErrorMessage name="recieverName" />
          </span>
        </div>

        <div>
          <label htmlFor="message">
            {config?.options?.noPlaceholders
              ? null
              : config?.configFields.message.label}
          </label>
          <Field
            name="message"
            type="text"
            as="textarea"
            placeholder={config?.configFields.message.placeholder}
          />
          <span className="error">
            <ErrorMessage name="message" />
          </span>
        </div>
        <button type="submit">{config?.configFields.button}</button>
      </Form>
    </Formik>
  );
};
export default GiftCardForm;
